// frontend/src/routes.jsx
import { Routes, Route } from "react-router-dom";

import Clientes   from "./paginas/Clientes/index.jsx";
import Caixa      from "./paginas/Caixa/index.jsx";
import Inicio     from "./paginas/Inicio/index.jsx";
import Vendas     from "./paginas/Vendas/index.jsx";
import Financeiro from "./paginas/Financeiro/index.jsx";
import Banco      from "./paginas/Banco/indexsaldo.jsx";
import Bancocad   from "./paginas/Banco/indexcad.jsx";
import Despesas   from "./paginas/Despesas/index.jsx";
import Notafiscal from "./paginas/Nfs/index.jsx";
import Chat       from "./paginas/Chat/index.jsx";
import Erro       from "./paginas/Erro/index.jsx";
import P2PPage    from "./pages/P2PPage.jsx";

import Spinner    from "./components/Spinner/carregando.jsx";
import Calculadora from "./components/Calculadora/index.jsx";

import SignUp     from "./paginas/SignUp/index.jsx";
import SignIn     from "./paginas/SignIn/index.jsx";

import Dashboard  from "./paginas/Dashboard";          // <— aqui!
import PrivateRoute from "./components/PrivateRoute";
import Header     from "./components/Header/index.jsx";
import Footer     from "./components/Footer/index.jsx";
import ui from "./styles/ui.module.css";
import IN1888     from "./paginas/IN1888";

export default function RoutesApp() {
  return (
    <>
      <Header />
      <div className={ui.appContent}>
      <Routes>
        {/* rotas públicas */}
        <Route path="/" element={<SignIn />} />
        <Route path="signup" element={<SignUp />} />
        <Route path="inicio" element={<Inicio />} />
        <Route path="Calculadora" element={<Calculadora />} />
        <Route path="Spinner"     element={<Spinner />} />

        {/* rotas publicas adicionais */}
        <Route path="P2P" element={<P2PPage />} />

        {/* rotas protegidas (só acessíveis após login) */}
        <Route element={<PrivateRoute />}>
          <Route path="Vendas"      element={<Vendas />} />
          <Route path="Clientes"    element={<Clientes />} />
          <Route path="Caixa"       element={<Caixa />} />
          <Route path="Banco"       element={<Banco />} />
          <Route path="Bancocad"    element={<Bancocad />} />
          <Route path="Despesas"    element={<Despesas />} />
          <Route path="Notafiscal"  element={<Notafiscal />} />
          <Route path="Financeiro"  element={<Financeiro />} />
          <Route path="Chat"        element={<Chat />} />
          

          {/* exibe o Dashboard (por exemplo, em /Dashboard) */}
          <Route path="Dashboard" element={<Dashboard />} />
          <Route path="IN1888" element={<IN1888 />} />
        </Route>

        {/* fallback para qualquer rota inválida */}
        <Route path="*" element={<Erro />} />
      </Routes>
      </div>
      <Footer />
   </>
  );
}
